module.exports = __webpack_public_path__ + "img/shopping1.add70ff7.png";